import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Spinner } from '@blueprintjs/core';
import { statusSelector, errorSelector, initSocket, isConnectingSelector } from '../../features/websocket/websocketSlice'
import './WebsocketStatus.css';

const status2type = {
    closed: 'info',
    connected: 'success',
    warning: 'warning',
    error: 'error',
};

const WebsocketStatusManager = () => {
    const dispatch = useDispatch()
    const status = useSelector(statusSelector)
    const error = useSelector(errorSelector)
    const connecting = useSelector(isConnectingSelector)

    const msg = {
        connected: 'connected',
        closed: 'not connected',
        warning: error,
        error: error,
    };


    const connect = (retry) => initSocket(retry)(dispatch)

    useEffect(() => {
        connect();
    }, [dispatch]);

    return (
        <div
            className={`btn-status btn-${status2type[status]} ${connecting ? 'btn-loading' : ''}`}
            style={{ cursor: 'default' }}
        >
            {connecting ? (
                <Spinner size={20} />
            ) : (
                <span>
                    {msg[status]}
                </span>
            )}
        </div>
    );
};

// Function for establishing a connection that is used in ConfigureSessionPage
export const connectToWebSocket = (dispatch, retry = true) => {
    dispatch(initSocket(retry));
};

export default WebsocketStatusManager
